export type SessionStatusType = "success" | "warning" | "info" | "error";

/** i18n keys under `customer-service:channel.*` — translate at render. */
export const CHANNEL_LABEL_KEYS: Record<string, string> = {
  // 1010:后端真实落库的渠道值(cs_sessions.channel / channel_type)
  wecom_kf: "channel.wecomKf",
  web_widget: "channel.webWidget",
  wecom: "channel.wecom",
  web: "channel.web",
  wechat_mini: "channel.wechatMini",
  api: "channel.api",
};

/** 会话列表渠道筛选(值直传后端 `channel` 参数;all = 不传)。 */
export const CHANNEL_FILTER_OPTIONS: { value: string; labelKey: string }[] = [
  { value: "all", labelKey: "sessions.channelAll" },
  { value: "wecom_kf", labelKey: "sessions.channelWecomKf" },
  { value: "web_widget", labelKey: "sessions.channelWebWidget" },
];

/** 渠道标签:web_widget 带接入点名 →「网页 / H5 · 官网」;未知渠道显示原值。 */
export function channelLabel(
  t: (key: string) => string,
  channel: string | null | undefined,
  entryName?: string | null
): string {
  const ch = channel ?? "";
  const key = CHANNEL_LABEL_KEYS[ch];
  const base = key ? t(key) : ch || "-";
  return entryName ? `${base} · ${entryName}` : base;
}

// Keys must match backend cs_sessions.status enum exactly.
// V26 (cs_sessions_unify_handover_status) merged 'transferred' into 'human_handling'.
export const SESSION_STATUS_KEYS: Record<string, { labelKey: string; type: SessionStatusType }> = {
  active: { labelKey: "sessionStatus.active", type: "info" },
  human_handling: { labelKey: "sessionStatus.humanHandling", type: "success" },
  closed: { labelKey: "sessionStatus.closed", type: "info" },
};

/** 未命中问题状态 → 中文(Batch 0.5 全中文化;CSV 导出与列表徽标共用语义)。 */
export const UNMATCHED_STATUS_LABELS: Record<string, string> = {
  open: "待处理",
  resolved: "已解决",
  ignored: "已忽略",
};

/** 消息角色 → i18n key(cs_message.role = customer|ai|human|system;老数据可能是 assistant / user)。未知角色返回 undefined,显示原值。 */
const MESSAGE_ROLE_KEYS: Record<string, string> = {
  customer: "messageRole.customer",
  user: "messageRole.customer",
  ai: "messageRole.ai",
  assistant: "messageRole.ai",
  human: "messageRole.human",
  system: "messageRole.system",
};
export function messageRoleLabelKey(role: string | null | undefined): string | undefined {
  return role ? MESSAGE_ROLE_KEYS[role] : undefined;
}
